import React, { useState } from 'react';
import styles from './CartItem.module.scss';
import { Link } from 'react-router-dom';
import routes from '../../../../routes';
import Edit from '../../../icons/Edit';
import DetailedView, { getImageTypeTitle } from './DetailedView';
import SimpleView from './SimpleView';
import Extras from './Extras';
import Footer from './Footer';
import { addonSheetToSheet } from '../../../PackageBuilders/MultiPose/functions';

export default function IndividualAddonItem({ orderPackage, removeItem, editable, waivesRetouching }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = () => setIsExpanded((prev) => !prev);

  const addonSheetsByName = orderPackage.addonSheets.reduce((acc, cur) => {
    const key = cur.addon.name.trim();

    if (acc[key]) acc[key].push(addonSheetToSheet(cur));
    else acc[key] = [addonSheetToSheet(cur)];

    return acc;
  }, {});

  const addonSheetTypes = [...new Set(orderPackage.addonSheets.map((sheet) => sheet.addon.name.trim()))]
    .map((name) => {
      const withoutNum = getImageTypeTitle(name);

      return `(${addonSheetsByName[name].length}) ${withoutNum}`;
    });

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerWrapper}>
        <div className={styles.bigTitle}>{orderPackage.package.name}</div>
      </div>
      <div className={styles.optionTitle}>{orderPackage.apiOption.name}</div>
      {editable && (
        <div className={styles.actions}>
          <Link to={routes.individualPrintEdit(orderPackage.id)}>
            <Edit onClick={() => { }} />
          </Link>
        </div>
      )}
      {orderPackage.addonSheets.length > 0 && (
        <div>
          <DetailedView sheetsByTypeName={addonSheetsByName} />
        </div>
      )}
      <Extras orderPackage={orderPackage} removeItem={removeItem} editable={editable} waivesRetouching={waivesRetouching} />
      <Footer orderPackage={orderPackage} removeItem={removeItem} editable={editable} />
    </div>
  )
}
